// DEPRECATED: Replaced by `src/rxdb/replication-v2/replication.ts`.
// TODO: clean up https://nutrien.atlassian.net/browse/MDP-8188
// We're deprecating this file so we don't care about `any`.
/* eslint-disable @typescript-eslint/no-explicit-any */
import type {
  MaybePromise,
  RxGraphQLReplicationPullQueryBuilder,
  RxGraphQLReplicationPushQueryBuilder,
} from 'rxdb';
import { WithDeleted } from 'rxdb';

import { SYNC_LIMIT_LOW } from '../../utilities/constants';
import { LiveInterval } from '../constants';
import { CheckpointType } from '../types';
import { Database } from './Database';
import {
  buildUrl,
  bypassDeleted,
  createConfigBuilder,
  pull,
  PullResponseModifier,
  push,
  PushResponseModifier,
  replicate,
  schedule,
} from './replicate';
import { RxdbCollectionNameV2 } from './RxdbCollectionNameV2';

// DEPRECATED: Replaced by `src/rxdb/replication-v2/replication.ts`.
// Use only the configuration a collection needs instead of relying on 10 different optional variables.
export const syncGraphQLFor = (
  idToken: string,
  rxdb: Database,
  collectionName: RxdbCollectionNameV2,
  pullQueryBuilder?: RxGraphQLReplicationPullQueryBuilder<CheckpointType> | null,
  pullModifier?: null | ((docData: any) => MaybePromise<WithDeleted<any>>),
  pushQueryBuilder?: RxGraphQLReplicationPushQueryBuilder | null,
  pushModifier?: null | ((docData: WithDeleted<any>) => MaybePromise<any>),
  // Used when we absolutely need to update a document that was already deleted
  // See comments on https://github.com/Nutrien/minesight-borer-app/pull/514/
  bypassDeletedFlag = false,
  live = true,
  syncInterval = LiveInterval.SECONDS_30,
  pullBatchSize = SYNC_LIMIT_LOW,
  overrideGraphQLURL?: string,
  retryTime = 3000,
  customResponseModifier?: PullResponseModifier<any>,
  // The ack for the mutation, not a transform of the outgoing doc (that's `pushModifier`).
  pushResponseModifier?: PushResponseModifier<any>,
) => {
  const configBuilder = createConfigBuilder(idToken, rxdb);
  const syncConfig = configBuilder(collectionName);
  if (overrideGraphQLURL) syncConfig.url = buildUrl(collectionName, overrideGraphQLURL);
  if (bypassDeletedFlag) bypassDeleted(syncConfig);
  syncConfig.live = live;
  syncConfig.retryTime = retryTime;

  if (pullQueryBuilder) {
    const pullConfig = pull(syncConfig, pullQueryBuilder, customResponseModifier);
    pullConfig.batchSize = pullBatchSize;
    if (pullModifier) pullConfig.modifier = pullModifier;
  }

  if (pushQueryBuilder) {
    const pushConfig = push(syncConfig, pushQueryBuilder);
    if (pushModifier) pushConfig.modifier = pushModifier;
    if (pushResponseModifier) pushConfig.responseModifier = pushResponseModifier;
  }

  const replicationState = replicate(syncConfig);

  return {
    replicationState,
    reSyncInterval: schedule(replicationState, syncInterval),
  };
};
